import { Col, Container, Row } from "react-bootstrap";
import AmenityForm from "../../../Components/Forms/AmenityForm/AmenityForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useAddNewAmenityMutation } from "../../../services/bClientApi";
import useUploadImage from "../../../Hooks/UseUploadImage/useUploadImageHook";

export default function AddAmenityPage() {

    const [
        addNewAmenity,
        {
            isLoading,
            error
        }
    ] = useAddNewAmenityMutation()

    const { uploadImageFn } = useUploadImage()

    const dispatch = useAppDispatch()
    const handleSubmit = async (data: any) => {
        const values: any = {
            ...data
        }
        const newAmenity = await addNewAmenity(values).unwrap()
        if (newAmenity._id) {
            dispatch(navigateTo(`/amenity/${newAmenity._id}`))
        }
        return newAmenity
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Add Amenity</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    <AmenityForm
                        initialValues={{
                            type: '',
                            isActive: true,
                            featured: false,
                        }}
                        disabled={isLoading}
                        onSubmit={handleSubmit}
                        uploadImageFn={uploadImageFn}
                    />

                </Col>
            </Row>
        </Container>
    )
}
